import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicLayout from "@/components/layout/PublicLayout";

export default function NotFound() {
  return (
    <PublicLayout>
      <section className="oc-section flex items-center justify-center min-h-[60vh]">
        <div className="text-center max-w-md">
          <div className="w-14 h-14 mx-auto rounded-full bg-oc-subtle flex items-center justify-center">
            <Search className="w-6 h-6 text-oc-primary" />
          </div>
          <p className="mt-6 font-mono text-oc-textSecondary text-[13px] uppercase tracking-[0.1em]">404 — niet gevonden</p>
          <h1 className="mt-3 font-display text-oc-primary text-[36px] font-bold">Pagina niet gevonden</h1>
          <p className="mt-3 text-oc-textSecondary">De pagina die je zoekt bestaat niet of is verplaatst.</p>
          <Link to="/">
            <Button className="mt-7 bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn h-12 px-7 font-semibold">
              Terug naar home
            </Button>
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
